import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import authService from "../../services/common/authService";
import MainLayout from "../Layout/MainLayout";
import toastHelper from "../../utilities/toastHelper";

const ProtectedRoute = ({ element: Element, withLayout }) => {
  const isAuthenticated = authService.getCurrentUser();

  useEffect(() => {
    if (!isAuthenticated) return;

    // Password expiry / first login checks
    const isFirstLogin = localStorage.getItem("isFirstLogin");
    if (
      isFirstLogin === "true" &&
      window.location.pathname !== "/set-password"
    ) {
      window.location.replace("/set-password"); // full redirect is okay here
    }

    const passwordExpiryDays = localStorage.getItem("passwordExpiryDays");
    if (passwordExpiryDays) {
      const days = parseInt(passwordExpiryDays, 10);
      if (days > 0 && days <= 7) {
        toastHelper.info(`Your password will expire in ${days} days.`);
      } else if (days <= 0 && window.location.pathname !== "/change-password") {
        toastHelper.error("Your password has expired.");
        window.location.replace("/change-password");
      }
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />; // login page
  }

  const content = (
    <>
      <Element />
    </>
  );
  const currentUser = authService.getCurrentUser();

  return withLayout ? (
    <MainLayout formData={currentUser} onLogout={authService.logout}>
      {content}
    </MainLayout>
  ) : (
    content
  );
};

export default ProtectedRoute;
